import { Navigate } from "react-router-dom";

/** Rota antiga /servidor/marketplace — foi retirada do menu em 14/07/2026 quando
 *  o cliente pediu "esse espaço é apenas para ofertas que o banco criar e
 *  publicar". A tela real dessas ofertas hoje é /servidor/marketplace/portabilidade.
 *  Redirect com replace=true pra links diretos antigos caírem no destino certo
 *  sem poluir o histórico do navegador. Auditoria UX 27/07/2026 tier 4 —
 *  decisão: consolidação da duplicação (era arquivo de 141 linhas mostrando
 *  ofertas identicas ao marketplace-portabilidade, sem menu apontando pra ele). */
export function ServidorMarketplace() {
  return <Navigate to="/servidor/marketplace/portabilidade" replace />;
}
